import { Share2, FileText, LayoutDashboard, MessageSquareText } from "lucide-react";
import Reveal from "./Reveal";

const CARDS = [
  {
    icon: Share2,
    title: "Non riparti da zero",
    body:
      "Il Property Advisor può partire dal percorso che hai già completato in ValutaGenio, dai tuoi obiettivi e dalle analisi già disponibili.",
  },
  {
    icon: FileText,
    title: "Un professionista indipendente",
    body:
      "Ogni Property Advisor opera con il proprio ruolo, le proprie qualifiche e, quando richieste, le relative abilitazioni professionali.",
  },
  {
    icon: LayoutDashboard,
    title: "La tua esperienza conta",
    body:
      "Dopo una telefonata di orientamento o un successivo percorso professionale, potrai raccontare la tua esperienza e indicare se consiglieresti quel Property Advisor ad altri proprietari.",
  },
  {
    icon: MessageSquareText,
    title: "La reputazione si costruisce nel tempo",
    body:
      "I feedback legati a esperienze reali contribuiranno a rendere più trasparente la reputazione dei professionisti, valorizzando ciò che viene apprezzato e facendo emergere anche gli aspetti migliorabili.",
  },
];

export default function AgentsSection() {
  return (
    <section
      id="agenti"
      data-testid="agents-section"
      className="bg-[#404040] py-20 md:py-28 relative overflow-hidden"
    >
      {/* Vignette */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/20 pointer-events-none" />

      <div className="relative max-w-[1200px] mx-auto px-6 md:px-8">
        {/* Header */}
        <Reveal className="text-center max-w-3xl mx-auto">
          <span className="inline-block text-xs uppercase tracking-[0.2em] font-semibold text-[#B40101] mb-4">
            Property Advisor
          </span>
          <h2 className="font-display font-bold text-white text-4xl md:text-5xl lg:text-[52px] tracking-tight leading-[1.1]">
            La fiducia si costruisce anche dopo il primo contatto
          </h2>
          <p className="mt-6 text-white/75 text-lg md:text-xl leading-relaxed">
            ValutaGenio mette il proprietario nelle condizioni di arrivare più preparato al confronto con un professionista immobiliare. Il Property Advisor è un professionista indipendente presente sulla piattaforma e, quando richiedi un confronto, può partire dalle informazioni e dalle analisi che hai già completato.
          </p>
        </Reveal>

        {/* Cards grid */}
        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {CARDS.map((card, i) => {
            const Icon = card.icon;
            return (
              <Reveal key={card.title} delay={i * 100}>
                <div
                  data-testid={`agents-card-${i}`}
                  className="group relative bg-white/[0.04] border border-white/10 rounded-xl p-7 md:p-8 h-full transition-all duration-200 hover:bg-white/[0.06] hover:border-white/20 hover:-translate-y-1 backdrop-blur-sm"
                >
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 rounded-xl bg-[#B40101]/15 border border-[#B40101]/30 flex items-center justify-center flex-shrink-0">
                      <Icon className="w-5 h-5 text-[#B40101]" strokeWidth={2.2} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="text-white/40 font-mono text-[11px] tracking-widest mb-1.5">
                        0{i + 1}
                      </div>
                      <h3 className="font-display font-bold text-white text-xl md:text-[22px] tracking-tight mb-3 leading-snug">
                        {card.title}
                      </h3>
                      <p className="text-white/70 text-[15px] md:text-[16px] leading-relaxed">
                        {card.body}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Precisazione */}
        <Reveal delay={460} className="mt-12 md:mt-16 flex justify-center">
          <div
            data-testid="agents-precisazione"
            className="max-w-[820px] mx-auto bg-black/25 border border-white/10 rounded-xl px-6 md:px-10 py-7 md:py-9 backdrop-blur-sm"
          >
            <div className="flex items-start gap-4">
              <div className="hidden md:flex w-1 self-stretch bg-[#B40101] rounded-full flex-shrink-0" aria-hidden="true" />
              <div>
                <p className="text-white/85 text-[15px] md:text-[17px] leading-relaxed">
                  Nel tempo, le esperienze raccolte attraverso ValutaGenio potranno diventare uno strumento di orientamento per i proprietari e un patrimonio reputazionale per i professionisti che lavorano con qualità e continuità.
                </p>
                <p className="mt-3 text-white/85 text-[15px] md:text-[17px] leading-relaxed">
                  Le attività professionali riservate restano soggette ai requisiti e alle abilitazioni previsti per ciascuna professione.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
